var map = {
	"./feature_buy_cn.png": 47906,
	"./feature_buy_en.png": 59556,
	"./feature_buy_id.png": 59642,
	"./feature_buy_ko.png": 52899,
	"./feature_buy_ph.png": 15065,
	"./feature_buy_th.png": 77261,
	"./feature_buy_zh.png": 52615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18670;